export default "__VITE_PUBLIC_ASSET__0f42d329__"